// Example of how a component should be initialized via JavaScript
// This script logs the value of the component's text property model message to the console
// eslint-disable-next-line sonarjs/cognitive-complexity
;(function () {
  'use strict'
  function onDocumentReady() {
    const scrollToTop = document.querySelector('.cmp-footer__scroll-to-top-button')

    scrollToTop?.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })

      // Move focus off the footer button so keyboard users land back at the top of the page,
      // instead of the visual scroll happening while focus silently stays in the footer.
      const skipLink = document.querySelector('.cmp-page__skiptomaincontent-link')
      if (skipLink) {
        skipLink?.focus({ preventScroll: true })
      } else {
        // If no skip link is present, move focus to the first focusable element in the main content area
        const mainContent = document.querySelector('main')
        if (mainContent) {
          const firstFocusable = mainContent.querySelector(
            'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])',
          )
          firstFocusable?.focus({ preventScroll: true })
        }
      }
    })
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
